import {Component} from "../Component";
import {element} from "../CustomElement";
import {Page, renderFooter, renderSingleRow} from "../flipp-page/Page";
import {i18n} from "../../i18n/I18n";
import {fetchJSON} from "../../utils/fetch";
import {orderBy, uniqBy, upperFirst} from "lodash-es";
import {inject} from "../../services/di";
import {ConfigService} from "../../services/ConfigService";
import {LocationService} from "../../services/LocationService";

export interface LinkData {
	name: string;
	link: string;
}

type StoreCityFlyersModel = {
	cities: LinkData[],
};

@element("store-city-flyers")
export class StoreCityFlyers extends Component<any, any> {
	@inject config: ConfigService;
	@inject location: LocationService;

	async prepare() {
		const json = await fetchJSON(`${this.config.FLIPP_COM_APIS}/city?country=ca`);
		const cities = [] as LinkData[];
		const getInCityName = (state: string, city: string) => {
			const cityName = city
				.split(" ")
				.map((c: string) => c.toLowerCase())
				.join("-")
				.replace("'", "");
			return `${cityName}-${state.toLowerCase()}`;
		};
		orderBy(uniqBy(json as {cityName: string, state: string}[], "cityName"), (city) => city.cityName.toLowerCase(), ["asc"]).forEach((cityState) => {
			const link = `/${getInCityName(cityState.state, cityState.cityName)}/stores`;
			const name = cityState.cityName.split(" ").map(item => (upperFirst(item))).join(" ");
			const item = { name, link };
			cities.push(item);
		});
		return {cities} as StoreCityFlyersModel;
	}

	render({cities}: StoreCityFlyersModel) {
		return <Page show="flyers">
			<div class="marketing link-hub">
				<div class="content-wrapper">
					<h1>{i18n("storeCityFlyers_title")}</h1>
					<ul class="all-cities">
						{cities.map((city) => (
							renderSingleRow({
								link: city.link,
								text: i18n("store_locationStore", { city: city.name }),
								locale: this.location.locale
							})
						))}
					</ul>
				</div>
				{renderFooter(this.location.locale)}
			</div>
		</Page>;
	}

}
